import { createAction, props } from '@ngrx/store';

import { VarietyPropertiesTGAResponse, VarietyPropertiesTGAUpsertRequest, CropVariety, ProductionPurposeCategory } from '../models/tga-varieties.model';

// Load TGA Variety Properties
export const loadTGAVarietyPropertiesRequest = createAction('[TGA Varieties] Load TGA Variety Properties request');

export const loadTGAVarietyPropertiesSuccess = createAction(
  '[TGA Varieties] Load TGA Variety Properties success',
  props<{ varietyProperties: VarietyPropertiesTGAResponse[] }>(),
);

export const loadTGAVarietyPropertiesFailure = createAction('[TGA Varieties] Load TGA Variety Properties failure', props<{ error: string }>());

// Upsert TGA Variety Property
export const upsertTGAVarietyPropertyRequest = createAction(
  '[TGA Varieties] Upsert TGA Variety Property request',
  props<{ varietyProperty: VarietyPropertiesTGAUpsertRequest }>(),
);

export const upsertTGAVarietyPropertySuccess = createAction(
  '[TGA Varieties] Upsert TGA Variety Property success',
  props<{ varietyProperty: VarietyPropertiesTGAUpsertRequest }>(),
);

export const upsertTGAVarietyPropertyFailure = createAction('[TGA Varieties] Upsert TGA Variety Property failure', props<{ error: string }>());

// Dialog Actions
export const openCreateTGAVarietyPropertyDialog = createAction('[TGA Varieties] Open Create TGA Variety Property Dialog');

export const openEditTGAVarietyPropertyDialog = createAction(
  '[TGA Varieties] Open Edit TGA Variety Property Dialog',
  props<{ varietyProperty: VarietyPropertiesTGAResponse }>(),
);

// Delete TGA Variety Property
export const deleteTGAVarietyPropertyRequest = createAction('[TGA Varieties] Delete TGA Variety Property request', props<{ id: number }>());

export const deleteTGAVarietyPropertySuccess = createAction('[TGA Varieties] Delete TGA Variety Property success');

export const deleteTGAVarietyPropertyFailure = createAction('[TGA Varieties] Delete TGA Variety Property failure', props<{ error: string }>());

// Load Crop Varieties
export const loadCropVarietiesRequest = createAction('[TGA Varieties] Load Crop Varieties request');

export const loadCropVarietiesSuccess = createAction('[TGA Varieties] Load Crop Varieties success', props<{ cropVarieties: CropVariety[] }>());

export const loadCropVarietiesFailure = createAction('[TGA Varieties] Load Crop Varieties failure', props<{ error: string }>());

// Load Production Purpose Categories
export const loadProductionPurposeCategoriesRequest = createAction('[TGA Varieties] Load Production Purpose Categories request');

export const loadProductionPurposeCategoriesSuccess = createAction(
  '[TGA Varieties] Load Production Purpose Categories success',
  props<{ productionPurposeCategories: ProductionPurposeCategory[] }>(),
);

export const loadProductionPurposeCategoriesFailure = createAction('[TGA Varieties] Load Production Purpose Categories failure', props<{ error: string }>());

export const loadVarietyPropertyTypesRequest = createAction('[TGA Varieties] Load Variety Property Types request');

export const loadVarietyPropertyTypesSuccess = createAction('[TGA Varieties] Load Variety Property Types success', props<{ cropVarieties: CropVariety[] }>());

export const loadVarietyPropertyTypesFailure = createAction('[TGA Varieties] Load Variety Property Types failure', props<{ error: string }>());
